import type { TemplateConfig } from "~/schemas/template";
import { useTemplateStore as useBaseTemplateStore } from "@anggunpraya-templates/base/app/stores/template";

export function useTemplateStore() {
  return useBaseTemplateStore() as ReturnType<typeof useBaseTemplateStore> & {
    template: TemplateConfig;
  };
}
